import { Reveal } from "./Reveal";
import { CalendarCheck, Flame, Send } from "lucide-react";

const STEPS = [
    { icon: Send, title: "Anfrage senden", text: "Kurz schreiben oder anrufen — ich melde mich schnell zurück." },
    { icon: CalendarCheck, title: "Termin finden", text: "Wir klären Menge, Länge und Liefertermin ganz entspannt." },
    { icon: Flame, title: "Einheizen & entspannen", text: "Der 7,5-t-Lkw bringt alles bis vor Ihre Tür. Sie lehnen sich zurück." },
];

export const Sorglos = () => (
    <section className="mx-auto max-w-7xl px-6 py-20 lg:py-28" data-testid="sorglos-section">
        <Reveal className="text-center">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#C88A45]">So einfach läuft's</p>
            <h2 className="mx-auto mb-6 max-w-3xl font-display text-4xl font-extrabold uppercase tracking-tight text-[#EDE6DA] sm:text-5xl">
                Ohne Stress zum <span className="text-[#C88A45]">warmen Zuhause.</span>
            </h2>
            <p className="mx-auto max-w-xl text-sm leading-relaxed text-[#9C917D] sm:text-base">
                Sie fragen an — ich kümmere mich um den Rest. Sorglos, entspannt und pünktlich geliefert.
            </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-3">
            {STEPS.map((s, i) => (
                <Reveal key={s.title} delay={i * 0.12}>
                    <div className="rounded border border-[#2E2517] bg-[#1B150E] p-8 text-center" data-testid={`sorglos-step-${i}`}>
                        <span className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full border border-[#2E2517] text-[#C88A45]">
                            <s.icon size={20} />
                        </span>
                        <h3 className="font-display text-lg font-bold uppercase tracking-tight text-[#EDE6DA]">{s.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-[#9C917D]">{s.text}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
